<template>
  <div class="result">
    <AppNavbar
      v-if="isApp"
      :placeholder="true"
      :options="options"
      :zIndex="999"
      :title="title"
    >
      <div slot="right" v-if="![12].includes($route.query.que_type * 1)">
        <span class="share iconfont icon-share1" @click="bindShare"></span>
      </div>
    </AppNavbar>
    <DownloadApp
      v-else-if="!isApp && $route.query.que_type != 11"
      :placeholder="true"
    ></DownloadApp>
    <router-view @copyUrl="changeCopyUrl"></router-view>
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :shareType="shareType"
      :copyUrl="copyUrl"
      :hideIconId="4"
      :shareOptions="shareOptions"
    />
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
import ShareComponent from '@/components/app/share/share-image.vue'
import DownloadApp from './components/download-app.vue'
import { getShareData } from './common.js'
export default {
  components: {
    AppNavbar,
    ShareComponent,
    DownloadApp
  },
  data() {
    return {
      isApp: false,
      options: {},
      title: '',
      showShare: false,
      shareType: 1,
      copyUrl: '',
      shareOptions: {},
      info: null
    }
  },
  created() {
    this.isApp = this.$http._isApp()
    this.shareOptions = getShareData(this.$route.query)
    this.title = (this.$route.meta && this.$route.meta.title) || ''
    this.$http.addDataLog({
      eventk: 'SHOW_common_questions_result',
      eventv: this.$route.query.que_type
    })
  },
  methods: {
    changeCopyUrl(url) {
      console.log(url)
      this.copyUrl = url
    },
    bindShare() {
      this.showShare = true
    },
    bindCloseShare() {
      this.showShare = false
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  min-height: 100vh;
  background-color: #f7f7f7;

  .container {
    min-height: 60vh;
    position: relative;
    background-image: linear-gradient(
      180deg,
      rgba(209, 164, 233, 1) 0px,
      rgba(169, 157, 251, 0) 350px
    );
    padding: 56px 16px 30px;
    box-sizing: border-box;
  }

  .bg {
    position: absolute;
    right: 30px;
    top: 10px;
    width: 121px;
    height: 109px;
    object-fit: contain;
  }

  .c-item {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .c-title {
    display: flex;
    align-items: center;
    margin-bottom: 16px;

    .title-icon {
      width: 26px;
      height: 26px;
      object-fit: contain;
      margin-right: 6px;
    }

    .title-text {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #27243c;
      line-height: 28px;
    }
  }

  .gray-title {
    display: inline-block;
    position: relative;
    font-size: 15px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #27243c;
    line-height: 21px;
    margin-bottom: 16px;
  }

  .gray-title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 7px;
    background: linear-gradient(
      270deg,
      rgba(159, 145, 254, 0) 0%,
      #9f91fe 100%
    );
    border-radius: 8px;
    opacity: 0.5;
  }

  .top {
    .user-info {
      width: 100%;
      margin-top: -47px;
      text-align: center;
      padding-bottom: 12px;
      border-bottom: 1px dashed rgba(58, 55, 82, 0.16);

      .avatar {
        margin: 0 auto;
        width: 54px;
        height: 54px;
        border: 2.5px solid #fff;
        box-sizing: border-box;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 6px;

        .avatar-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .nickname {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 22px;
      }
    }

    .t-title {
      margin-top: 12px;
      position: relative;
      z-index: 0;

      .t-desc {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(39, 36, 60, 0.8);
        line-height: 22px;
        margin-bottom: 2px;
      }

      .t-text {
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 29px;
      }

      .t-line {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 220px;
        height: 8px;
        background: linear-gradient(
          270deg,
          rgba(254, 102, 132, 0) 0%,
          #fe6684 100%
        );
        border-radius: 4px;
        z-index: -1;
      }
    }

    .t-body {
      width: 144px;
      height: 250px;
      margin: 34px auto 0px;
      position: relative;

      .t-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .tag-list {
        .tag-item {
          width: 89px;
          box-sizing: border-box;
          position: absolute;
          background: #ffebef;
          border-radius: 6px;
          padding: 8px 10px;

          .tag-el {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 13px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            line-height: 18px;
            padding-bottom: 4px;
            border-bottom: 1px dashed #fe6684;
          }

          .tag-status {
            margin-top: 2px;
            font-size: 16px;
            font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
            font-weight: 600;
            line-height: 22px;
          }

          .tag-danger {
            position: absolute;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            text-align: center;
            line-height: 20px;
            left: 12px;
            top: 0px;
            color: #fff;
            transform: translate(0%, -60%);
            background: linear-gradient(180deg, #ff98b4 0%, #fe6684 100%);
            font-size: 16px;
            font-weight: 600;
          }
        }

        .green {
          background: #e7f6ee;
          color: #7dd0a4;

          .tag-el {
            border-bottom: 1px dashed rgba(125, 208, 164, 0.24);
          }
        }

        .yellow {
          background: #fdf4de;
          color: #fbb754;

          .tag-el {
            border-bottom: 1px dashed rgba(250, 189, 100, 0.24);
          }
        }

        .red {
          background: #ffebef;
          color: #fe6684;

          .tag-el {
            border-bottom: 1px dashed rgba(254, 102, 132, 0.24);
          }
        }

        .tag-item:first-child {
          right: 0px;
          bottom: 16.5px;
          transform: translate(100%, 0%);
        }

        .tag-item:nth-child(2) {
          right: 0px;
          top: 2px;
          transform: translate(100%, 0%);
        }

        .tag-item:nth-child(3) {
          right: 0px;
          bottom: 99px;
          transform: translate(100%, 0%);
        }

        .tag-item:nth-child(4) {
          left: 0px;
          bottom: 58.5px;
          transform: translate(-100%, 0%);
        }

        .tag-item:nth-child(5) {
          left: 0px;
          top: 36px;
          transform: translate(-100%, 0%);
        }
      }
    }
  }

  .ele-content {
    padding-left: 0px;
    padding-right: 0px;

    .ele-c {
      padding: 24px 20px 0px;

      .ele-top {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }

      .ele-title {
        display: inline-block;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 33px;
        margin-right: 8px;
      }

      .ele-status {
        display: inline-block;
        height: 16px;
        background: #fe6684;
        border-radius: 2px;
        font-size: 10px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 16px;
        padding: 0px 4px;
      }

      .red {
        background: #fe6684;
      }

      .green {
        background: #7dd0a4;
      }

      .yellow {
        background: #fbb754;
      }

      .ele-desc {
        margin-bottom: 16px;
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(39, 36, 60, 0.45);
        line-height: 20px;
      }

      .ele-text {
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 20px;
      }

      .ele-suggest {
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(39, 36, 60, 0.45);
        line-height: 20px;
      }
    }
  }

  .rank-content {
    .food-recommend-list {
      width: 100%;
      margin-bottom: 20px;

      .f-r-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .f-index {
          font-size: 18px;
          font-family: DINPro-Bold, DINPro;
          font-weight: bold;
          color: rgba(39, 36, 60, 0.26);
          line-height: 23px;
          margin-right: 10px;
        }

        .f-center {
          position: relative;
          height: 24px;
          line-height: 24px;
          background: linear-gradient(
            270deg,
            rgba(233, 195, 255, 0.8) 0%,
            rgba(243, 227, 255, 0.3) 100%
          );
          flex: 1;
          flex-shrink: 0;
          padding: 0px 10px;
          white-space: nowrap;
          text-overflow: ellipsis;

          .f-name {
            font-size: 11px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: #27243c;
            line-height: 20px;
            margin-right: 16px;
          }

          .f-desc {
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(39, 36, 60, 0.8);
            line-height: 20px;
          }
        }

        .f-center::after {
          content: '';
          position: absolute;
          left: 100%;
          top: 0;
          width: 0;
          height: 0;
          border-left: 8px solid rgba(233, 195, 255, 0.8);
          border-top: 12px solid transparent;
          border-bottom: 12px solid transparent;
        }

        .f-image {
          width: 38px;
          height: 38px;
          margin-left: 20px;
        }

        .f-space {
          width: 0;
        }
      }
    }
  }

  .recommend-food {
    background: #ffffff;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e1dede;
    display: flex;
    align-items: center;
    position: relative;

    .recommend-food-image {
      object-fit: cover;
      width: 85px;
      height: 85px;
      margin-right: 16px;
    }

    .recommend-right {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .food-name {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 21px;
      }

      .btn {
        margin-top: 15px;
        display: inline-flex;
        padding: 0px 8px 0px 13px;
        height: 22px;
        align-items: center;
        border-radius: 11px;
        border: 1px solid #ba8ce0;
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #ba8ce0;
      }

      .desc {
        width: 170px;
        font-size: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(39, 36, 60, 0.45);
        line-height: 18px;
        margin-top: 4px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box; //将元素设为盒子伸缩模型显示
        -webkit-box-orient: vertical; //伸缩方向设为垂直方向
        -webkit-line-clamp: 2; //超出3行隐藏，并显示省略号
      }
    }

    .flag {
      position: absolute;
      top: 0;
      height: 24px;
      right: 0;
      background: #fe6684;
      border-radius: 0px 6px 0px 6px;
      padding: 0px 6px 0px 10px;
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 24px;
    }
  }

  .literature {
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.4);
    line-height: 14px;

    .literature-item {
      margin-bottom: 8px;
    }
  }
}

::v-deep .van-tabs__nav {
  box-sizing: border-box;
  border-bottom: 1px solid rgba(58, 55, 82, 0.09);
  padding-bottom: 10px;
}

::v-deep .van-tab {
  font-size: 13px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: rgba(39, 36, 60, 0.36);
}

::v-deep .van-tabs__line {
  width: 42px;
  height: 3px;
  background: #ba8ce0;
  border-radius: 3px;
  bottom: 0;
}

::v-deep .van-tab--active {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ba8ce0;
}

.logo {
  height: 12px;
  margin: 20px auto 0px;
}

.share {
  font-size: 24px;
}
</style>
